module.exports = __webpack_public_path__ + "img/Ebike Commuter city.448dbfa.svg";